import React from "react";
import {useParams} from "react-router";
import UserList from "./list";
import UserDetail from "./detail";

export default function UserTab() {
  const {userNo} = useParams();

  if (userNo) {
    return <UserDetail/>;
  }
  return <UserList/>;
}
